import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaBlock } from './CtaBlock';
export function Guarantee() {
  return <section className="border-t border-ink-700 bg-ink-950 px-4 py-12 sm:px-6 sm:py-16" data-id="element-132" data-mp="1o2vhap4uen6k">
      <div className="mx-auto w-full max-w-2xl rounded-2xl border border-brand/40 bg-ink-800 p-6 text-center sm:p-8" data-id="element-133" data-mp="222d7n8xse8i1">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand/15" data-id="element-134" data-mp="1x4v27sizabes">
          <ShieldCheckIcon className="h-7 w-7 text-brand" aria-hidden="true" data-id="element-135" data-mp="19f0o77mxagsy" />
        </div>
        <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-136" data-mp="14h8ymk9r36rx">
          Probiere es 7 Tage lang ohne Risiko aus
        </p>
        <h2 className="mt-2 font-display text-[24px] uppercase leading-tight text-white sm:text-3xl" data-id="element-137" data-mp="1ee3qwlffkaxr">
          Dein Kauf ist durch eine 7-Tage-Zufriedenheitsgarantie geschützt
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-white/70" data-id="element-138" data-mp="lp6f915q5cdz">
          Wenn du die Meister-Handbücher durchgehst, das System ausprobierst und feststellst, dass es
          nicht deinen Erwartungen entspricht, kontaktiere uns innerhalb der Garantiefrist.
        </p>
        <p className="mt-4 font-display text-sm uppercase tracking-[0.14em] text-brand" data-id="element-139" data-mp="twi3avw3p5k6">
          Einfach. Klar. Ohne unnötige Komplikationen.
        </p>
        <p className="mt-2 text-sm text-white/60" data-id="element-140" data-mp="12pv74svpdrl1">
          Du kannst das System ohne unnötiges Risiko testen.
        </p>

        <CtaBlock label="Risikofrei starten" showTimer={false} note="7 Tage Garantie · Einmalige Zahlung von 19 €" className="mt-6" data-id="element-141" data-mp="62i4yuqpj2j3" />
      </div>
    </section>;
}